module.exports = __webpack_public_path__ + "img/invoice-disabled.ede13de6.svg";